import { object, string, date } from 'yup';

export const schema = object().shape({
    flightNumber: string()
        .required('Flight number is required')
        .min(3, 'Must be at least 3 characters')
        .matches(/[a-zA-Z]/, 'Must contain at least one letter'),
    flightDate: date()
        .required('Flight date is required')
        .typeError('Flight date must be a valid date'),
    type: string().required('Type is required'),
    unit: string().required('Unit is required'),
    collectionId: string().required('Collection ID is required'),
    createdBy: string()
        .email('Created by must be a valid email')
        .required('Created by is required'),
    createdAt: date()
        .required('Created at is required')
        .typeError('Created at must be a valid date'),
});
